/* eslint-disable import/no-anonymous-default-export */
import * as actions from './actions';
import { accountTypeCodes } from '../../utils/constants';

export type State = {
  loading: boolean;
  data: Array<Record<string, any>>;
  error: object;
};

export default (
  state: State = {
    loading: false,
    data: [],
    error: {},
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.FETCH_ACCOUNT_TYPES:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_ACCOUNT_TYPES_SUCCESS:
      const accountTypesContent =
        action.payload &&
        action.payload.map((ac: any) => {
          return {
            value: ac.elements.overrideAccountTypeCode.value,
            name: ac.elements.displayName.value,
            contributionType: ac.elements.contributionType.value,
          };
        });
      // accountTypesContent.push({ value: accountTypeCodes.PENSION, name: accountTypeCodes.PENSION });

      return {
        ...state,
        data: accountTypesContent,
      };
    case actions.FETCH_ACCOUNT_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
